import React from 'react';
import { Image, Text, View } from 'react-native';
import { getImageByKey } from '../../utils/ImagesManagementUtils';
import { img_arrow_right_button, verify_recipient_icon } from '../../utils/DictionaryManagementUtils';
import { getRegularFont } from '../../utils/Utils';

//= ========================================================================
const InputField = ({
  globJSON,
  simPlatform,
  inputKey,
  inputText,
  iconGray,
  isFormFilled,
  showIcon,
  isArrow,
}) => {
  const fontFamily = `${getRegularFont(globJSON, simPlatform)}`;
  const { colors } = globJSON.configurations.theme;

  const myStyle = {
    container: {
      flexDirection: 'row',
    },
    inputContainer: {
      borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? 3 : 9,
      border: `solid 0.6px ${colors.border_color}`,
      backgroundColor: colors.app_background_color,
      padding: 9,
      flexBasis: showIcon ? '82%' : '100%',
    },
    inputHeadline: {
      fontFamily,
      fontSize: 9.3,
      color: isFormFilled ? colors.primary_font_color : colors.tertiary_icons_color,
    },
    inputIcon: {
      width: isArrow ? 17 : 24,
      height: isArrow ? 17 : 24,
      margin: 'auto',
      tintColor: colors.cta_font_color,
    },
    btnBackground: {
      width: 30,
      height: 30,
      marginStart: 5,
      borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? 5 : 15,
      backgroundColor: iconGray ? colors.disabled_cta_color : colors.primary_cta_color,
    },
  };
  return (
    <View style={myStyle.container}>
      <View key={inputKey} style={myStyle.inputContainer}>
        <Text style={myStyle.inputHeadline}>{inputText}</Text>
      </View>
      {showIcon && (
        <View style={myStyle.btnBackground}>
          <Image
            fadeDuration={0}
            resizeMode="contain"
            style={myStyle.inputIcon}
            source={isArrow
              ? getImageByKey(globJSON.configurations.general.img_arrow_right_button, img_arrow_right_button)
              : getImageByKey(globJSON.configurations.general.verify_recipient_icon, verify_recipient_icon)}
          />
        </View>
      )}
    </View>

  );
};

export default InputField;
